// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_rentalNeed_broadcasts_edges_node_activityReport(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["ActivityReportV5"]);
}

function unwrap_fragment_rentalNeed_status(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "ActiveRentalNeed",
    "ExpiredRentalNeed",
    "RentedRentalNeed",
    "WithdrawnRentalNeed"
  ]);
}

let fragmentConverter = {"__root":{"rentalNeed_status":{"u":"fragment_rentalNeed_status"},"rentalNeed_broadcasts_edges_node_activityReport":{"u":"fragment_rentalNeed_broadcasts_edges_node_activityReport"},"":{"f":""}}};

let fragmentConverterMap = {
  fragment_rentalNeed_broadcasts_edges_node_activityReport: unwrap_fragment_rentalNeed_broadcasts_edges_node_activityReport,
  fragment_rentalNeed_status: unwrap_fragment_rentalNeed_status
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyClientsWidgetRenter_Menu_renter",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "RentalNeedV5",
        "kind": "LinkedField",
        "name": "rentalNeed",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isRenewable",
                      "storageKey": null
                    }
                  ],
                  "type": "ActiveRentalNeed",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "ExpiredRentalNeed",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "RentedRentalNeed",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "WithdrawnRentalNeed",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            "action": "THROW"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "dismissalState",
                "value": "UNDISMISSED"
              }
            ],
            "concreteType": "RentalNeedMatchConnection",
            "kind": "LinkedField",
            "name": "matches",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              }
            ],
            "storageKey": "matches(dismissalState:\"UNDISMISSED\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "RentalNeedBroadcastConnection",
            "kind": "LinkedField",
            "name": "broadcasts",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "RentalNeedBroadcastEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": "RentalNeedBroadcast",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "activityReport",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v2/*: any*/),
                                  "type": "ActivityReportV5",
                                  "abstractKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            "action": "NONE"
                          }
                        ],
                        "storageKey": null
                      },
                      "action": "NONE"
                    }
                  ],
                  "storageKey": null
                },
                "action": "NONE"
              }
            ],
            "storageKey": "broadcasts(first:1)"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MyClientsWidgetDeleteDialog_clientV5"
    }
  ],
  "type": "Renter",
  "abstractKey": null
};
})());

let wrap_fragment_rentalNeed_broadcasts_edges_node_activityReport = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_rentalNeed_status = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_rentalNeed_broadcasts_edges_node_activityReport = unwrap_fragment_rentalNeed_broadcasts_edges_node_activityReport;
exports.wrap_fragment_rentalNeed_broadcasts_edges_node_activityReport = wrap_fragment_rentalNeed_broadcasts_edges_node_activityReport;
exports.unwrap_fragment_rentalNeed_status = unwrap_fragment_rentalNeed_status;
exports.wrap_fragment_rentalNeed_status = wrap_fragment_rentalNeed_status;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
